import * as classNames from 'classnames';
import * as React from 'react';
import {ControlButton, TscButtonType, Glyphs, SlideToggle} from '@techsmith/tsc-cloud-style-guide';
import Constants, {UserTypes, ModalStates} from '../../globals/Constants';
import UserModel from '../../types/UserModel';
import AvatarWrapper from '../AvatarWrapper/AvatarWrapper';
import Strings from '../../globals/Strings';
import SimpleReviewerModel from '../../types/SimpleReviewerModel';
import Themeable from '../../types/Themeable';

export default ({reviewer, themeName, user, cancelRemoveReviewer, isSaving, removeReviewer, notifyReviewer, modalState}: OwnerReviewerProps) => {
   const classes = classNames('row', {'removing-row': reviewer.Status === Constants.reviewerStatus.removing}, {failed: reviewer.Status === Constants.reviewerStatus.failed});
   const linkToggleClasses = classNames('send-link-toggle', {'default-cursor': reviewer.Status === Constants.reviewerStatus.removing});
   let reviewerUser: UserModel = user;
   if (!reviewerUser) {
      reviewerUser = {
         userId: reviewer.Id,
         email: reviewer.Email,
         avatarUrl: null,
         name: reviewer.Email,
         isDeleted: !reviewer.Email ? true : false,
         userType: UserTypes.techSmith
      };
   }

   const deleteReviewer = (): void => {
      if (!isSaving) {
         removeReviewer(reviewer);
      }
   };

   const onToggleSendLink = (): void => {
      if (reviewer.Status !== Constants.reviewerStatus.removing && !isSaving) {
         notifyReviewer(reviewer, !reviewer.Notify);
      }
   };

   const getLabelStatusText = (r: SimpleReviewerModel): string => {
      if (r.Status === Constants.reviewerStatus.removing) {
         return Strings.labels.manageReviewersList.removingLabel;
      } else if (r.Status === Constants.reviewerStatus.pending) {
         return Strings.labels.manageReviewersList.pendingLabel;
      } else if (r.Status === Constants.reviewerStatus.failed) {
         return Strings.labels.manageReviewersList.failedLabel;
      } else if (r.Status === Constants.reviewerStatus.added) {
         return Strings.labels.manageReviewersList.addedLabel;
      } else {
         return '';
      }
   };

   const cancelRemoveReviewerClick = () => {
      cancelRemoveReviewer(reviewer);
   };

   return (
      <div className={classes}>
         <div className="reviewer-avatar-glyph">
               <AvatarWrapper key={reviewer.Id} user={reviewerUser} />
         </div>
         <div className="reviewer-email" title={reviewer.Email}>
               <div className="reviewer-email-text">
               {reviewer.Email}
               </div>
               <div className="reviewer-status">
               {getLabelStatusText(reviewer)}
               </div>
         </div>
         {modalState !== ModalStates.manageReviewerGroups && <div className={linkToggleClasses}>
               <SlideToggle labelText={Strings.labels.shareReviewLink.sendLink} isChecked={reviewer.Notify} onClick={onToggleSendLink}/>
         </div>}
         {reviewer.Status !== Constants.reviewerStatus.removing && <div className="delete-reviewer-glyph-open-reviews">
               <ControlButton themeName={themeName} buttonType={TscButtonType.tertiary} isFullWidth={false} onClick={deleteReviewer} title={Strings.labels.removeReviewer} testId="delete-reviewer" glyph={<Glyphs.CircleRemove24x24/>}/>
         </div>}
         {reviewer.Status === Constants.reviewerStatus.removing && cancelRemoveReviewer && <div className="add-reviewer-glyph">
               <ControlButton themeName={themeName} buttonType={TscButtonType.tertiary} isFullWidth={false} onClick={cancelRemoveReviewerClick} title={Strings.labels.cancelRemoveReviewer} testId="cancel-delete-reviewer" glyph={<Glyphs.CircleAdd24x24/>} />
         </div>}
      </div>
   );
};

export interface OwnerReviewerProps extends Themeable {
   user: UserModel;
   reviewer: SimpleReviewerModel;
   isSaving: boolean;
   modalState: ModalStates;
   removeReviewer(reviewer: SimpleReviewerModel): void;
   cancelRemoveReviewer(reviewer: SimpleReviewerModel): void;
   notifyReviewer(reviewer: SimpleReviewerModel, wantToNotify: boolean): void;
}
